import { Inject, Injectable, InjectionToken } from '@angular/core';
import { AppwriteConfig } from '@prism/prism-shared';
import { Client } from 'appwrite';

export const APPWRITE_CONFIG_TOKEN = new InjectionToken<AppwriteConfig>('AppwriteConfig');

@Injectable()
export class AppwriteClientService {
    public readonly client: Client;
    public readonly config: AppwriteConfig;

    constructor(@Inject(APPWRITE_CONFIG_TOKEN) config: AppwriteConfig) {
        this.config = config;
        this.client = new Client()
            .setEndpoint(config.endpoint)
            .setProject(config.projectId);
    }
}
